import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43227088"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "far fa-check-circle me-2" }),
    /*#__PURE__*/_createTextVNode("จบโครงการ")
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "card-subtitle text-muted" }, "จบโครงการเพื่อป้องกันการแก้ไขข้อมูลโครงการที่ดำเนินการเสร็จสิ้นแล้ว")
], -1))
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  key: 0,
  class: "text-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-check-circle me-2" }, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "text-center text-warning"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-hourglass me-2" }, null, -1))
const _hoisted_8 = {
  key: 2,
  class: "text-center text-success"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-check-circle me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isCanceled || _ctx.isCompleted || _ctx.isDone || _ctx.isFinished)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          ((_ctx.isCanceled || _ctx.isCompleted) && !_ctx.isDone && !_ctx.isFinished)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("button", {
                  class: "btn btn-success",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.requestClick && _ctx.requestClick(...args)))
                }, [
                  _hoisted_5,
                  _createTextVNode(" ยื่นคำร้องขอจบโครงการ ")
                ])
              ]))
            : _createCommentVNode("", true),
          ((_ctx.isCanceled || _ctx.isCompleted) && _ctx.isDone && !_ctx.isFinished)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createTextVNode("รอการอนุมัติ ")
              ]))
            : _createCommentVNode("", true),
          ((_ctx.isCanceled || _ctx.isCompleted) && _ctx.isDone && _ctx.isFinished)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createTextVNode("จบโครงการแล้ว ")
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}